// removed by extract-text-webpack-plugin
module.exports = {"content":"_26n_j22XkeU9mS-e1fuz4Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleTabContent/SimpleTabContent.scss
// module id = 1316
// module chunks = 1